import { render, staticRenderFns } from "./administrators-selection.vue?vue&type=template&id=553338e5&scoped=true&"
import script from "./administrators-selection.vue?vue&type=script&lang=ts&"
export * from "./administrators-selection.vue?vue&type=script&lang=ts&"
import style0 from "./administrators-selection.vue?vue&type=style&index=0&id=553338e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553338e5",
  null
  
)

export default component.exports